import React from "react";
import { Provider } from "react-redux";
import { useTranslation } from "react-i18next";
import "./App.css";
import { store } from "./app/store";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import ThemeContainer from "./components/Containers/ThemeContainer";
import AppRouter from "./router/AppRouter";
import MetaSDKLoader from "./components/Containers/MetaSDKLoader";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { UploadFilesProvider } from "./contexts/UploadFilesContext";
import { ChatProvider } from "./contexts/ChatContext";
import { getDateFnsLocale } from "./utils/i18nLanguage";
import { initSentry } from "./utils/sentryReporting";
import { installGlobalErrorHandlers } from "./utils/globalErrorHandlers";
import AppErrorBoundary from "./components/Containers/AppErrorBoundary";

import { LaunchError } from "./utils/errors";

const stripePromise = (async () => {
  try {
    return await loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);
  } catch (err) {
    store.dispatch(
      LaunchError(err, false, [], {
        functionName: "stripePromise",
        capture: "exception",
      })
    );
    console.error(err);
    window.location.reload();
  }
})();

initSentry();
installGlobalErrorHandlers();

function App() {
  const { i18n } = useTranslation();
  const adapterLocale = getDateFnsLocale(i18n.language);

  return (
    <React.Fragment>
      <AppErrorBoundary>
        <Elements stripe={stripePromise}>
          <Provider store={store}>
            <ThemeContainer>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={adapterLocale}
              >
                <UploadFilesProvider>
                  <MetaSDKLoader />
                  <ChatProvider>
                    <AppRouter />
                  </ChatProvider>
                </UploadFilesProvider>
              </LocalizationProvider>
            </ThemeContainer>
          </Provider>
        </Elements>
      </AppErrorBoundary>
    </React.Fragment>
  );
}

export default App;
